import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("High")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Normal")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Set ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Confirm ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx._visible,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx._visible) = $event)),
    onCancel: _ctx.handleCancel,
    maskClosable: false
  }, {
    title: _withCtx(() => [
      _hoisted_4
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_a_button, { onClick: _ctx.handleCancel }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.handleConfirm,
        loading: _ctx.loading
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          ref: "formRef",
          model: _ctx.formState,
          rules: _ctx.rules,
          "label-col": _ctx.labelCol,
          "wrapper-col": _ctx.wrapperCol
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "Set Time Line",
              name: "timeLine"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_range_picker, {
                  value: _ctx.formState.timeLine,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.timeLine) = $event)),
                  "value-format": "YYYY-MM-DD"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "assignJob",
              label: "Assign Job"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  placeholder: "please select",
                  value: _ctx.formState.assignJob,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.assignJob) = $event)),
                  allowClear: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.user, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: item.usrid,
                        key: item.usrid
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.fulnm), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              name: "priority",
              label: "Priority"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  placeholder: "please select",
                  value: _ctx.formState.priority,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.priority) = $event)),
                  allowClear: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules", "label-col", "wrapper-col"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}